module.exports = __webpack_public_path__ + "static/media/calmap.88d1c2f1.png";